import { Component, OnInit } from '@angular/core';
import { Checklist } from "../../../classes/checklist";
import { ChecklistService } from '../../../services/checklist';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-checklist-create',
  templateUrl: './checklist-create.component.html',
  styleUrls: ['./checklist-create.component.css']
})
export class ChecklistCreateComponent implements OnInit {

  checklist = new Checklist();
  checklistCreationResult = true;

  constructor(private router: Router,
              private checklistService: ChecklistService) { }

  ngOnInit(): void {}

  onSubmit() {
    this.checklistService.create(this.checklist)
      .subscribe({
        next: () => {
          this.router.navigate(['/checklist']);
        },
        error: (err: HttpErrorResponse) => {
          this.checklistCreationResult = false;
          console.log(err);
        }
      });
  }

}
